import { Component, OnDestroy, OnInit } from '@angular/core';
import { ClientService } from '@services/client.service';
import { RefDataService } from '@services/ref-data.service';
import { TranslateService } from '@ngx-translate/core';
import { NotificationService } from '@services/notification.service';
import { UserService } from '@services/user.service';
import { Router } from '@angular/router';
import { Client } from '../models/client.model';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-clients-search',
  templateUrl: './clients-search.component.html',
  styleUrls: ['./clients-search.component.scss'],
  standalone: false,
})
export class ClientsSearchComponent implements OnInit, OnDestroy {
  clientList: Client[] = [];
  clientListOriginal: Client[] = [];
  allNatures: any[] = [];
  searchTxt = '';

  // subject used to unsubscribe to avoid memory leaks on component destruction
  private readonly destroy$ = new Subject<void>();

  constructor(
    private clientService: ClientService,
    private translateService: TranslateService,
    private notificationService: NotificationService,
    private userService: UserService,
    private router: Router,
    private refDataService: RefDataService,
  ) {}

  ngOnInit(): void {
    this.clientService
      .getClientList()
      .pipe(takeUntil(this.destroy$))
      .subscribe((list) => {
        this.clientList = list;
        this.clientListOriginal = list;
      });

    this.refDataService
      .getByKey('clientNatures', true)
      .pipe(takeUntil(this.destroy$))
      .subscribe((clientNatures) => {
        this.allNatures = this.refDataService.toArray(clientNatures);
      });
  }

  search(): void {
    this.clientList = this.clientListOriginal.filter((client) => client.name.toUpperCase().includes(this.searchTxt.toUpperCase()));
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  notify(_: any): void {
    this.notificationService.sendSuccess(this.translateService.instant('APPLICATIONS.LIST.COPY_BTN_SUCCESS'));
  }

  goToClient(url: string, rightList: string[]): void {
    if (this.haveAccess(rightList)) {
      this.router.navigate([url]);
    }
  }

  haveAccess(rightList: string[]): boolean {
    return this.userService.haveAccess(rightList);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
